import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-thin-arrow-left",
  "use": "icon-thin-arrow-left-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" fill=\"currentColor\" id=\"icon-thin-arrow-left\">\n  <g id=\"icon-thin-arrow-left_Thin_Arrow_Left\">\n    <path d=\"M12.394,16l0.435-0.366L8.041,10l4.787-5.634L12.394,4l-5.222,6L12.394,16z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol